<script>
    import {showDialogLogin} from "../../../js/stores";
    import {API_URL} from "../../../../env";
    import {addAlert} from "../../../js/alert";

    let tokenSent = false

    let fetching = false
    async function sendVerificationEmail() {
        if (fetching) return;
        fetching = true

        let body = {
            email: $showDialogLogin.data.email
        }

        const res = await fetch(API_URL+'/users/sendVerificationToken', {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })

        if (res.ok) {
            return tokenSent = true
        }
        addAlert("danger", "Chyba", "Niekde nastala chyba, skúste to prosím znova.")
    }
</script>

{#if !tokenSent}
    <i class="far fa-fw fa-circle-xmark"></i>
    <div class="dc-title mb-3">Váš e-mail nie je overený.</div>
    <p>Potvrďte ho prosím z odkazu v e-maile, ktorý sme Vám poslali pri registrácii, prípadne kliknite <button type="button" class="btn btn-link" on:click={sendVerificationEmail}>tu</button> pre jeho opätovné zaslanie.</p>
{:else}
    <i class="far fa-fw fa-circle-check"></i>
    <div class="dc-title">E-mail bol úspešne odoslaný..</div>
{/if}

<style>
    i {
        font-size: 3rem;
        margin-bottom: 1.5rem;
    }
    .dc-title {
        font-size: 1.5rem;
        font-weight: 600;
    }
</style>